import { Component, Input, OnInit, DoCheck } from "@angular/core";
import { SecurityConfig } from "../../../../edtell-admin/interfaces/route-security-config.interface";
import { EdtellTabConfig } from "../../../interface/edtell-tabset.config";

@Component({
  selector: "app-edtell-tab",
  templateUrl: "./edtell-tab.component.html",
  styleUrls: ["./edtell-tab.component.scss"],
})
export class EdtellTabComponent implements OnInit, DoCheck {
  @Input() title: string;

  @Input() config?: EdtellTabConfig;

  security: SecurityConfig;

  tabOpen = false;

  constructor() {}

  ngOnInit() {
    if (this.config && this.config.security) {
      this.security = this.config.security;
    }
  }

  ngDoCheck() {
    this.ngOnInit();
  }
}
